import { type CardStylingDataStructure } from 'javascripts/shared-types';
import CardStyling from '../CardStyling';
import {
  type CardLayoutModelConstructorType,
  type StatusableType,
} from '../types';
import { type CardStylingTypesEnum_value } from 'components/framework/models/generated/types';
import { currentFlavorSupportsTeams } from 'javascripts/util/currentFlavorSupportsTeams';

export class SidebarStatus extends CardStyling {
  static type: CardStylingTypesEnum_value = 'SidebarStatus';
  static title: string = 'Status (sidebar)';

  static subqueriesForModel(_modelClass: CardLayoutModelConstructorType) {
    if (currentFlavorSupportsTeams()) {
      return { teamWorkflowStatus: ['color'] };
    } else {
      return { workflowStatus: ['color'] };
    }
  }

  exampleCardStyling() {
    return { highlightColor: '--aha-green-500' };
  }

  cardStyling(record: StatusableType): CardStylingDataStructure {
    const status =
      currentFlavorSupportsTeams() && 'teamWorkflowStatus' in record
        ? record.teamWorkflowStatus
        : record.workflowStatus;
    if (!status) return {};
    const { colorObject } = status;
    const highlightColor = colorObject.hex();

    return { highlightColor };
  }
}
